import EfBundlesActivity from '@elem/ui/ef-bundles-activity';
import EfCountDown from '@elem/ui/ef-count-down';
import EfSpec from '@elem/ui/ef-spec';
import EfTitle from '@elem/ui/ef-title';
import { useRouter } from 'next/router';
import { Fragment, useEffect, useState } from 'react';
import { IPageStatus } from '../../../config/IPageStatus';
import { useProductStore } from '../../../ProductProvider';
import TimerTips from '../../common/TimerTips';
import styles from './index.module.scss';
import ItemB from './ItemB';
import { getIsLogin } from '@/utils/cookie';
import { getListProducts } from '@/service/membersstore';
import { useLang } from '@/i18n';
import { ProductModule } from '@/components/MembersDay/type';

export default function TheComp() {
    const { pageStatus, timeLine, systemTime } = useProductStore();
    const { locale = 'jp' } = useRouter();
    const { t } = useLang('theProduct.SectionG');
    const { t: t2 } = useLang('theProduct.Common');
    const isNextTimer = pageStatus !== IPageStatus.statusA;

    const buyText = isNextTimer ? t('buy_text2') : t('buy_text1'); //购买按钮-文案
    const buyStatus = isNextTimer ? 'default' : 'disabled'; //购买按钮-链接
    const loginText = isNextTimer ? t('login_text') : t('buy_text1');
    const list_name = pageStatus === IPageStatus.statusC ? t('title2') : t('title');
    const [isLogin, setIsLogin] = useState(false);
    const [itemsA, setItemsA] = useState([
        {
            productId: '8095160795297',
            variantId: '44597213003937',
            quantity: 1,
            buyStatus,
            buyText,
            loginText,
            list_name,
            moreLink: isNextTimer ? `/${locale}/delta-3-series-portable-power-station` : '',
        },
        {
            productId: '8095169249441',
            variantId: '44498880888993',
            quantity: 1,
            buyStatus,
            buyText,
            loginText,
            list_name,
            moreLink: isNextTimer ? `/${locale}/delta-3-series-portable-power-station` : '',
        },
        {
            productId: '8095171477665',
            variantId: '44498830721185',
            quantity: 1,
            buyStatus,
            buyText,
            loginText,
            list_name,
            moreLink: isNextTimer ? `/${locale}/delta-3-series-portable-power-station` : '',
        },
    ]);
    const [dataA, setDataA] = useState({
        titleKey: 'itemA',
        productId: '8097380106401',
        variantId: '44505650528417',
        quantity: 1,
        buyStatus,
        buyText,
        loginText,
        list_name,
        moreLink: isNextTimer ? `/${locale}/river-3-portable-power-station` : '',
    });
    const [dataB, setDataB] = useState({
        titleKey: 'itemB',
        productId: '8097380696225',
        variantId: '44505652854945',
        quantity: 1,
        buyStatus,
        buyText,
        loginText,
        list_name,
        moreLink: isNextTimer ? `/${locale}/river-3-portable-power-station` : '',
    });

    const initAll = async () => {
        const { data } = await getListProducts(
            {
                module: pageStatus == IPageStatus.statusA ? ProductModule.WARMUP : ProductModule.SALE,
                bizModule: 'JP3IN1_202408',
            },
            locale,
        );
        const variantObj: any = {};
        data.forEach((item: any) => (variantObj[`${item.variantId}`] = item));
        //列表
        const itemsB = JSON.parse(JSON.stringify(itemsA));
        itemsB.forEach((item: any) => {
            const variantItem = variantObj[`${item.variantId}`];
            if (variantItem) {
                item.img = variantItem.imageUrl;
                item.name = variantItem.title;
                item.discountPrice = variantItem.memberPrice;
                item.originalPrice = variantItem.compareAtPrice;
                item.inventoryQuantity = 10;
            }
        });
        setItemsA(itemsB);
        // 右侧-a
        const variantItemA = variantObj[`${dataA.variantId}`];
        if (variantItemA) {
            const dataA2 = JSON.parse(JSON.stringify(dataA));
            dataA2.img = variantItemA.imageUrl;
            dataA2.name = variantItemA.title;
            dataA2.discountPrice = variantItemA.memberPrice;
            dataA2.originalPrice = variantItemA.compareAtPrice;
            dataA2.inventoryQuantity = 10;
            setDataA(dataA2);
        }
        // 右侧-b
        const variantItemB = variantObj[`${dataB.variantId}`];
        if (variantItemB) {
            const dataB2 = JSON.parse(JSON.stringify(dataB));
            dataB2.img = variantItemB.imageUrl;
            dataB2.name = variantItemB.title;
            dataB2.discountPrice = variantItemB.memberPrice;
            dataB2.originalPrice = variantItemB.compareAtPrice;
            dataB2.inventoryQuantity = 10;
            setDataB(dataB2);
        }
    };

    const CountDownConfig = {
        statusA: {
            startTime: timeLine?.statusA?.start,
            endTime: timeLine?.statusB?.start,
            leftTips: t2('timer_tips_start'),
        },
        statusB: {
            startTime: timeLine?.statusB?.start,
            endTime: new Date('2024-08-31 23:00:00 GMT+8').getTime(),
            leftTips: t2('timer_tips'),
        },
    };
    let config = CountDownConfig.statusA;
    if (pageStatus === IPageStatus.statusB) {
        config = CountDownConfig.statusB;
    }
    // 计算剩余时间
    let leftTime = null;
    if (systemTime) {
        leftTime = config.endTime - systemTime;
    }

    useEffect(() => {
        const isLogin2 = getIsLogin();
        setIsLogin(isLogin2);
        initAll();
    }, []);

    return (
        <div className={styles.TheComp} id="section-SectionG">
            <EfSpec />
            <EfTitle>{list_name}</EfTitle>
            {pageStatus !== IPageStatus.statusC && (
                <>
                    <TimerTips title={t('desc')} />
                    <EfCountDown
                        leftTime={leftTime}
                        endTime={config.endTime}
                        leftTips={config.leftTips}
                        tipsDay={t2('timer_1')}
                        tipsHour={t2('timer_2')}
                        tipsMinute={t2('timer_3')}
                        tipsSecond={t2('timer_4')}
                    />
                </>
            )}
            <div className="ef-container SectionG-in">
                {itemsA.map((item: any, index: number) => (
                    <Fragment key={index}>
                        <EfBundlesActivity {...item} isNeedLogin={pageStatus !== IPageStatus.statusC} isLogin={isLogin} />
                    </Fragment>
                ))}
                <ItemB isNeedLogin={pageStatus !== IPageStatus.statusC} pageStatus={pageStatus} isLogin={isLogin} dataA={dataA} dataB={dataB} />
            </div>
        </div>
    );
}
